/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PROAUTH", "88")


  
    
export interface API20844Item {
  
  /** 资源父id */
  resourceParentId?: string;
  
  /** 名称 */
  name?: string;
  
  /** 英文名 */
  nameEn?: string;
  
  /** 跳转url */
  url?: string;
  
  /** icon */
  icon?: string;
  
  /** 序号 */
  sort?: number;
  
  /** 菜单层级 */
  level?: number;
  
  /**  */
  status?: string;
  
  /** 备注 */
  remark?: string;
  
  /** 资源id */
  resourceId?: string;
  
  /** 资源类型，MENU ACTION BUTTON */
  resourceType?: string;
  
  /** 资源菜单类型；  HIDE_MENU（隐藏菜单）  COMMON_MENU（普通菜单） */
  resourceMenuType?: string;
  
  /** PUBLISH PRIVATE */
  isPublish?: string;
  
  /** 是否拥有该资源 */
  isHasResourcce?: boolean;
  
  /** 菜单列表 ,ResourceMenuDto */
  childMenus?: API20844Item[];
  
};
    
  



export interface API20844Req {
  
  /** (String) */
  moduleId?: string;
    
};



export interface API20844Res {
  /** 菜单列表 ,ResourceMenuDto  */
  menuResourceList?: API20844Item[];
  /** 其他资源列表 ,ResourceMenuDto  */
  otherResourceList?: API20844Item[];
  /** 产品负责人名称  */
  productUserName?: string;
  /** 产品负责人id  */
  productUserId?: string;
  /** 导航栏展示类型，卡片式 CARD_DESIGN | 面包屑 BREADCRUMB  */
  showType?: string;
  
};


// 20844 获取模块下可视模块资源

export interface IUseGetAPI20844Return {
  /** 获取模块下可视模块资源: 接口请求状态 */
  isAPI20844Loading: boolean;
  /** 获取模块下可视模块资源: 接口请求返回数据 */
  dataAPI20844: API20844Res;
  /**  获取模块下可视模块资源: 接口数据请求方法 */
  fetchAPI20844Data:  (inputs: API20844Req, config?: YWRequestConfig) => Promise<API20844Res>;
  /** 获取模块下可视模块资源: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI20844 = ():IUseGetAPI20844Return => {
  let isMount = true;
  const [isAPI20844Loading, setIsAPI20844Loading] = useState(false);
  const [dataAPI20844, setDataAPI20844] = useState<API20844Res>({} as API20844Res);
  const requestUrl = `${basePath}/ywwl-admin/desktop/resource/module/list`;

  const fetchAPI20844Data = async (inputs: API20844Req, config?: YWRequestConfig): Promise<API20844Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API20844Req>) || {}) as API20844Req;
    
  
    if ( isMount ) {
      setIsAPI20844Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API20844Res>(`${basePath}/ywwl-admin/desktop/resource/module/list?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI20844(res || {} as API20844Res);
        setIsAPI20844Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI20844Loading(false);
      }
      return false as unknown as API20844Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI20844Loading,
    dataAPI20844,
    fetchAPI20844Data,
    requestUrl,
  }
}

